import {
  finalSaleDoc,
  itemsAutoStock,
  itemsWithBatch,
  noStockDoc,
} from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import { arrangeBatches } from "../../../../utils/arrangeBatches";
import { getBatchesInfo } from "../batches/getBatchesInfo";
import { openBatchModal } from "../batches/openBatchModal";

export const updateCheckStock = async (
  index: number,
  transferIn = false,
  openQty = false,
  params: stdObject,
) => {
  const {
    returnData,
    user,
    items,
    docValues,
    setDocValues,
    setMsg,
    setModalData,
    setWindowValues,
    logoutAction,
  } = params;
  if (user.STOROL === 0) {
    setMsg("accessBlocked");
  } else {
    let tempDocValues = docValues;
    const { serie, type, itemType } = tempDocValues;
    let rowLine = tempDocValues.items[index];

    const artCode = rowLine[`ART${itemType}`];

    if (!noStockDoc.includes(type)) {
      const artType = items[artCode]?.TIPART;
      const quantity = rowLine[`CAN${itemType}`];
      const pending = transferIn
        ? rowLine[`PEN2${itemType}`]
        : rowLine[`PEN${itemType}`];

      if (
        user.STOROL === 3 &&
        finalSaleDoc.includes(type) &&
        itemsWithBatch.includes(artType) &&
        openQty
      ) {
        const serie2 =
          type === "TRA" && serie !== user.CODSUC ? user.CODSUC : 0;
        let resultBatches: stdObject = await getBatchesInfo({
          itemCode: artCode,
          docValues,
          row: rowLine,
          serie2,
          setMsg,
          logoutAction,
        });
        setMsg("");
        const { success, status, available } = resultBatches;
        let batchQty = 0;
        if (success && status && available.length) {
          batchQty = available[0].CANBA1;
          batchQty = quantity > batchQty ? batchQty : quantity;
          rowLine[`PEN${itemType}`] = batchQty;
        }
        if (batchQty > 0) {
          const { batchesTable, batchesBox } = arrangeBatches({
            data: {
              line: rowLine[`LIN${itemType}`],
              item: artCode,
              serie2: 0,
            },
            table: [
              {
                data: {
                  IDBA0: available[0].IDBA1,
                  CANBA0: batchQty,
                  EXPBAT: available[0].EXPBAT,
                },
              },
            ],
            batchesBox: rowLine.BATCHES ?? [],
          });
          tempDocValues.batches[rowLine[`LIN${itemType}`]] = batchesTable;
          rowLine.BATCHES = batchesBox;
        }
      } else if (
        itemsAutoStock.includes(artType) &&
        ([2, 3].includes(user.STOROL) || quantity === 1)
      ) {
        rowLine[transferIn ? `PEN2${itemType}` : `PEN${itemType}`] =
          pending === 0 &&
          (itemsAutoStock.includes(artType) || !(artCode in items))
            ? quantity
            : 0;
      } else {
        openBatchModal(index, artCode, rowLine, openQty, {
          user,
          items,
          docValues,
          setMsg,
          setModalData,
          setWindowValues,
          logoutAction,
        });
      }
    }
    if (returnData) {
      return tempDocValues;
    } else {
      setDocValues({ ...tempDocValues });
    }
  }
};
